/*
 *
 * Nutrients
 *
 */

import React from "react";
import { connect } from "react-redux";
import {
  setTitle,
  setLoader,
  setBreadcrumb,
  delayedDispatch,
  updateCrumb,
} from "store/actions";
import { Table } from "components";
import { EditSidebar } from "components/EditSidebar";
import { Helmet } from "react-helmet";
import Strings from "utils/strings";
import { API, Endpoints } from "utils/api";
import { toast } from "utils/utils";
import moment from "moment";
import "./styles.scss";

export class Nutrients extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      language: "pt",
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // change this
    dispatch(setTitle(Strings.sidebar.nutrients));

    delayedDispatch(
      setBreadcrumb(() => {
        return {
          locations: [
            {
              text: Strings.sidebar.settings,
              route: "/settings",
              icon: "preferences",
            },
            {
              text: Strings.sidebar.nutrients,
              //route: "/settings/nutrients",
              icon: "molecule",
            },
          ],
        };
      })
    );

    this.getNutrients();
  }

  componentDidUpdate() {
    const { dispatch } = this.props;

    dispatch(updateCrumb());
  }

  async getNutrients() {
    const response = await API.get({
      url: Endpoints.uriNutrients(),
    });

    if (response.ok) {
      this.setState({ nutrients: response.data.results });
    } else {
      return toast.error(response.data?.message || Strings.serverErrors.title);
    }
  }

  onSubmit = async () => {
    const { dispatch } = this.props;
    const { item } = this.state;

    if (!item?.name) {
      return toast.warn(Strings.errors.invalidFields);
    }
    console.log('ITEM', item)

    dispatch(setLoader(true));

    const request = item._id ? API.put : API.post;
    const id = item._id || "";

    const response = await request({
      url: Endpoints.uriNutrients(id),
      data: {
        name: item.name,
        formula: item.formula,
        isFormula: item.isFormula,
        isActive: item._id ? item.isActive : true,
      },
    });

    if (response.ok) {
      this.setState({
        nutrients: response.data.results,
        openSidebar: false,
        hasUnsavedFields: false,
      });
    } else {
      dispatch(setLoader(false));
      return toast.error(response.data?.message || Strings.serverErrors.title);
    }

    dispatch(setLoader(false));
  };

  deleteNutrient = async (id: string) => {
    const { dispatch } = this.props;
    dispatch(setLoader(true));

    const response = await API.delete({
      url: Endpoints.uriNutrients(id),
    });

    if (response.ok) {
      this.setState({ nutrients: response.data.results });
    } else {
      dispatch(setLoader(false));
      return toast.error(response.data?.message || Strings.serverErrors.title);
    }
    dispatch(setLoader(false));
  };

  toogleNutrient = async (original: any) => {
    const { dispatch } = this.props;
    dispatch(setLoader(true));

    let body = { isActive: !original.isActive };
    const response = await API.patch({
      url: Endpoints.uriNutrients(original._id),
      data: body,
    });

    if (response.ok) {
      this.setState({ nutrients: response.data.results });
    } else {
      dispatch(setLoader(false));
      return toast.error(response.data?.message || Strings.serverErrors.title);
    }
    dispatch(setLoader(false));
  };

  onChange = (field: string, value: any) => {
    const { item, language } = this.state;
    if (field === "name")
      this.setState({
        item: { ...item, [field]: { ...item[field], [language]: value } },
      });
    else this.setState({ item: { ...item, [field]: value } });
  };

  openSidebar = (value: any) => {
    this.setState({
      openSidebar: true,
      item: JSON.parse(JSON.stringify(value)),
    });
  };

  closeSidebar = () => {
    this.setState({ openSidebar: false });
  };

  renderDrawer() {
    const { item, language } = this.state;
    return (
      <EditSidebar
        title={Strings.nutrients.header}
        open={this.state.openSidebar}
        onClose={this.closeSidebar}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        defaultValue={this.state.item}
        language={language}
        onChangeLanguage={(lang: any) => this.setState({ language: lang })}
        closable={false}
        fields={[
          {
            field: "name",
            value: item?.name?.[language],
            type: "input",
            name: Strings.fields.name,
            required: true,
          },
          {
            field: "isFormula",
            value: item?.isFormula,
            type: "check",
            name: Strings.nutrients.formula,
          },
          item?.isFormula ? 
          {
            field: "formula",
            value: item?.formula,
            type: "input",
            name: Strings.nutrients.formula,
            required: item?.isFormula ? true : false,
          } : '',
          {
            version: moment.now(),
          },
        ]}
      />
    );
  }

  tokenize = (formula: any) => formula?.split(/(\d+)/)
    .map((token: any, idx: any) =>
      idx % 2
        ? <sub key={idx}>{token}</sub>
        : token
      ) || ''

  render() {
    const { nutrients = [], language } = this.state;

    return (
      <React.Fragment>
        <Helmet>
          <title>{Strings.sidebar.nutrients}</title>
          <meta name="description" content="Description of Nutrients" />
        </Helmet>
        <Table
          title={{
            icon: "molecule",
            title: Strings.sidebar.nutrients,
          }}
          data={nutrients}
          columns={[
            {
              Header: Strings.nutrients.header,
              id: "name",
              accessor: (row: any) => row,
              Cell: ({ value }) => {
                const name = value.isFormula ? value.name?.[language] + ' - ' : value.name?.[language]
                return <>
                  <span>{name}</span>
                  &nbsp;{this.tokenize(value.formula)}
                </>
              },
              type: "text",
            },
          ]}
          filterable
          add={{
            label: String(
              Strings.formatString(
                Strings.generic.addNew,
                Strings.nutrients.header.toLowerCase()
              )
            ),
            onClick: () => this.openSidebar({}),
          }}
          actions={{
            edit: (original, value) => ({
              onClick: () => this.openSidebar(original),
            }),
            remove: (original, value) => ({
              onClick: () => this.deleteNutrient(original._id),
            }),
            toggle: (original, value) => ({
              value: original.isActive,
              onChange: () => this.toogleNutrient(original),
            }),
          }}
        />
        {this.renderDrawer()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(Nutrients);
